import { message } from 'ant-design-vue'
let captcha = null
let currentCaptchaCallback = null

export function asyncLoadJS (callback) {
  currentCaptchaCallback = callback
  if (captcha) {
    captcha.show()
  } else {
    const script = document.createElement('script')
    script.src = 'https://turing.captcha.qcloud.com/TJCaptcha.js'
    script.onload = () => {
      try {
        // eslint-disable-next-line no-undef
        captcha = new TencentCaptcha(
          '194174459',
          (res) => {
            if (res.ret === 0) {
              const { ticket, errCode, errorMessage } = res
              if (errCode && errorMessage) {
                message.error(errorMessage)
              } else {
                // eslint-disable-next-line no-useless-call
                currentCaptchaCallback(ticket)
              }
            }
          },
          {
            userLanguage: 'zh-cn'
          }
        )
        // 调用方法，显示验证码
        captcha.show()
      } catch (error) {
        // 加载异常，调用验证码js加载错误处理函数
        message.error('验证码加载失败，请刷新页面重试')
      }
    }
    document.body.appendChild(script)
  }
}
